import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { connect } from "react-redux";
import Waves from "node-waves";
import { dateToStringWithMonth, getWeeknumber } from "../../Util/dateTime";
import {
  attemptGetSalaryObject,
  attemptUpdatePeriodInput,
  setOpenCalculator,
  attemptUpdateCell,
  getEmployeeSuggestions,
  attemtAddEmployeeToProject,
} from "./actions";
import SalaryTable from "./salaryTable";
import { semanticColors } from "../../Globals/styles";
import PageSpinner from "../../Common/pageSpinner";
import auth from "../../Login/authService";
import SuggestSelectInput from "../../Common/suggestSelectInput";
import { httpGet, httpPost } from "../../Util/http";
import { routeActions } from "redux-simple-router";

class Salary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSortedByEmployee: true,
      startWeek: getWeeknumber(new Date(this.props.queryObject.startDate)),
      endWeek: getWeeknumber(new Date(this.props.queryObject.endDate)),
      startDate: dateToStringWithMonth(
        new Date(this.props.queryObject.startDate)
      ),
      endDate: dateToStringWithMonth(new Date(this.props.queryObject.endDate)),
      addProjectSearch: "",
      projectSuggestions: [],
      spinner: false
    };
  }
  setSortedBy = (bool) => {
    this.setState({
      isSortedByEmployee: bool,
    });
  };
  componentDidMount = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentWillMount = () => {
    this.props.dispatch(
      attemptGetSalaryObject(
        this.props.queryObject.projectIds,
        new Date(this.props.queryObject.startDate),
        new Date(this.props.queryObject.endDate)
      )
    );
  };
  getProject = (id) => {
    return this.props.projects[id];
  };
  getEmployee = (id) => {
    return this.props.employees[id];
  };
  getPeriod = (id) => {
    return this.props.periods[id];
  };
  getDay = (id) => {
    return this.props.days[id];
  };
  getEmployeeTotalSum = (id) => {
    const { employees, periods, days } = this.props;
    let sum = 0;
    employees[id].periodIds.forEach((periodId) => {
      periods[periodId].weeks.forEach((dayId) => {
        sum += days[dayId].normalHours;
      });
    });
    return sum;
  };
  getEmployeeTotalSum2 = (id) => {
    const { employees, periods, days } = this.props;
    let sum = 0;
    employees[id].periodIds.forEach((periodId) => {
      periods[periodId].weeks.forEach((dayId) => {
        sum += days[dayId].normalHoursOrig + days[dayId].nightHoursOrig;
      });
    });
    return sum;
  };
  getEmployeeTotalOvertTimeSum = (id) => {
    const { employees, periods, days } = this.props;
    let sum = 0;
    employees[id].periodIds.forEach((periodId) => {
      periods[periodId].weeks.forEach((dayId) => {
        sum += days[dayId].nightHoursOrig;
      });
    });
    return sum;
  };
  setOpenCalculator = (dayId, updateObject) => {
    if (this.props.updateObject)
      updateObject.secondObject = this.props.updateObject;
    this.props.dispatch(setOpenCalculator(dayId, updateObject));
  };
  renderSalaryTables = () => {
    const {
      employees,
      projects,
      dispatch,
      openCalculator,
      employeeSuggestions,
    } = this.props;

    const updateDay = (
      dayId,
      normalHours,
      supplementRate,
      supplementHours,
      mileageNew,
      shackNew,
      absenceCode,
      updateObject
    ) => {
      dispatch(
        attemptUpdateCell(
          dayId,
          normalHours,
          supplementRate,
          supplementHours,
          mileageNew,
          shackNew,
          updateObject,
          absenceCode
        )
      );
    };
    const updatePeriodInput = (periodId, type, value, updateObject) =>
      dispatch(attemptUpdatePeriodInput(periodId, type, value, updateObject));
    if (this.state.isSortedByEmployee) {
      return Object.keys(employees).map((employeeId) => {
        return (
          <SalaryTable
            key={employeeId}
            startWeek={this.state.startWeek}
            endWeek={this.state.endWeek}
            periodIds={employees[employeeId].periodIds}
            getProject={this.getProject}
            getEmployee={this.getEmployee}
            getPeriod={this.getPeriod}
            getDay={this.getDay}
            isSortedByEmployee={this.state.isSortedByEmployee}
            headingId={employeeId}
            getEmployeeTotalSum={this.getEmployeeTotalSum}
            getEmployeeTotalSum2={this.getEmployeeTotalSum2}
            getEmployeeTotalOvertTimeSum={this.getEmployeeTotalOvertTimeSum}
            openCalculator={openCalculator}
            setOpenCalculator={this.setOpenCalculator}
            updateDay={updateDay}
            updatePeriodInput={updatePeriodInput}
            updateObject={this.props.updateObject}
            conflictingProjects={this.props.conflictingProjects}
          />
        );
      });
    } else {
      return Object.keys(projects).map((projectId) => {
        return (
          <SalaryTable
            key={projectId}
            startWeek={this.state.startWeek}
            endWeek={this.state.endWeek}
            periodIds={projects[projectId].periodIds}
            getProject={this.getProject}
            getEmployee={this.getEmployee}
            getPeriod={this.getPeriod}
            getDay={this.getDay}
            isSortedByEmployee={this.state.isSortedByEmployee}
            headingId={projectId}
            getEmployeeTotalSum={this.getEmployeeTotalSum}
            getEmployeeTotalSum2={this.getEmployeeTotalSum2}
            getEmployeeTotalOvertTimeSum={this.getEmployeeTotalOvertTimeSum}
            openCalculator={openCalculator}
            setOpenCalculator={this.setOpenCalculator}
            updateDay={updateDay}
            updatePeriodInput={updatePeriodInput}
            updateObject={this.props.updateObject}
            getEmployeeSuggestions={(val) =>
              dispatch(getEmployeeSuggestions(val, projectId))
            }
            employeeSuggestions={employeeSuggestions}
            attemtAddEmployeeToProject={(employeeId) =>
              dispatch(
                attemtAddEmployeeToProject(
                  employeeId,
                  projectId,
                  this.props.queryObject.startDate,
                  this.props.queryObject.endDate
                )
              )
            }
            conflictingProjects={this.props.conflictingProjects}
          />
        );
      });
    }
  };
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  stripSuggestions(suggestions, alreadyChosen) {
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
      var allowedSugg = true;
      //check if already chosen from suggestions
      alreadyChosen.forEach(function (chosen) {
        if (chosen.id === suggestion.id) allowedSugg = false;
      });

      if (allowedSugg) newSuggestions.push(suggestion);
    });
    return newSuggestions;
  }
  render() {
    const { queryObject, isLoading, dispatch } = this.props;
    var token = auth.getToken();
    let objToString = JSON.stringify({
      projectIds: queryObject.projectIds,
      dateFrom: queryObject.startDate,
      dateTo: queryObject.endDate,
      token: token,
    });
    var _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/salary/print?sal=" +
      objToString;

    return isLoading ? (
      <PageSpinner />
    ) : (
      <div style={styles.bottomPadding}>
        <div className="row" style={styles.header}>
          <div style={styles.headerDates}>
            {this.state.startDate} - {this.state.endDate}
          </div>
          <div style={styles.headerWeeks}>
            Uge {this.state.startWeek} - {this.state.endWeek}
          </div>
          <div style={styles.sortSwitch}>
            <button
              className={
                !this.state.isSortedByEmployee
                  ? "btn btn-info waves-btn"
                  : "btn btn-default waves-btn"
              }
              onClick={() => this.setSortedBy(false)}
              style={[styles.projectButton]}
            >
              Sag
            </button>
            <button
              className={
                !this.state.isSortedByEmployee
                  ? "btn btn-default waves-btn"
                  : "btn btn-info waves-btn"
              }
              onClick={() => this.setSortedBy(true)}
              style={[styles.employeeButton]}
            >
              Medarbejder
            </button>
          </div>
          <div style={styles.sorterLabel}>Sorter</div>
          <a
            style={styles.printLink}
            href={_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-print" aria-hidden="true"></i>
          </a>
          <div style={{
            float: "right",
            marginTop: "7.5px",
            marginRight: 28
          }}>

            <button
              className={
                "btn btn-default waves-btn"
              }
              onClick={async () => {
                this.setState({ spinner: true })
                var _url = process.env.REACT_APP_webApiEndPoint + "api/salary/reimport";
                await httpPost(_url, {
                  projectIds: this.props.queryObject.projectIds, dateFrom: new Date(this.props.queryObject.startDate), dateTo: new Date(this.props.queryObject.endDate)
                })
                await this.sleep(2000)
                window.location.reload();
              }}
              style={[styles.employeeButton]}
            >
              {this.state.spinner ? <PageSpinner style={{ color: 'black', fontSize: 11, top: '100%' }} /> : 'Synkronisèr'}

            </button>
          </div>
        </div>
        {this.renderSalaryTables()}
        <div className="col-xs-12">
          <SuggestSelectInput
            onChange={(value) => {
              this.setState({ addProjectSearch: value });
            }}
            onQuery={(q) => {
              var fetchUrl =
                process.env.REACT_APP_webApiEndPoint +
                `api/project/search?query=${q}&all=true`;
              if (!q) {
                this.setState({
                  projectSuggestions: [],
                });
                return;
              }
              return httpGet(fetchUrl)
                .then((response) => {
                  return response.json();
                })
                .then((json) => {
                  this.setState({
                    projectSuggestions: this.stripSuggestions(
                      json,
                      queryObject.projectIds.map((p) => ({ id: p }))
                    ),
                  });
                })
                .catch((e) => {
                  console.log(e);
                });
            }}
            suggestions={this.state.projectSuggestions}
            value={this.state.addProjectSearch}
            placeholder="Tilføj sag"
            onSelect={(proj) => {
              let objToString2 = JSON.stringify({
                ...queryObject,
                projectIds: [...queryObject.projectIds, proj.id],
              });
              dispatch(routeActions.push("/lon?obj=" + objToString2));
              window.location.reload();
            }}
          />
        </div>
      </div >
    );
  }
}

var styles = {
  header: {
    height: "50px",
  },
  headerDates: {
    float: "left",
    lineHeight: "50px",
  },
  bottomPadding: {
    paddingBottom: "155px",
  },
  headerWeeks: {
    width: "100px",
    lineHeight: "50px",
    position: "absolute",
    left: "50%",
    marginLeft: "-50px",
  },
  sortSwitch: {
    float: "right",
    marginTop: "7.5px",
  },
  projectButton: {
    borderRadius: "2px 0px 0px 2px",
    width: "50px",
  },
  employeeButton: {
    borderRadius: "0px 2px 2px 0px",
    width: "105px",
  },
  sorterLabel: {
    float: "right",
    marginRight: "10px",
    lineHeight: "50px",
  },
  printLink: {
    float: "right",
    lineHeight: "50px",
    fontSize: "20px",
    marginRight: "28px",
    color: semanticColors.text,
    ":hover": {
      color: "black",
    },
  },
};

const selectProps = (state) => {
  return {
    ...state.salaryReducer,
  };
};
Salary.propTypes = {
  dispatch: PropTypes.func.isRequired,
  queryObject: PropTypes.shape({
    projectIds: PropTypes.array.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
  }).isRequired,
  employees: PropTypes.object,
  periods: PropTypes.object,
  days: PropTypes.object,
  projects: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  conflictingProjects: PropTypes.object.isRequired,
};

export default connect(selectProps)(Radium(Salary));



// WEBPACK FOOTER //
// ./src/App/Project/Salary/salaryContainer.jsx